export default function modalResponseRender(
  response,
  dataAttributes,
  customResponse = false
) {
  let responseModal = $("#modalResponseSent");
  let responseModalDesc = responseModal.find(".message");
  let responseModalTitle = responseModal.find(".modal-title");
  let responseStatus = response.detail.status == "mail_sent" ? true : false;
  let emailValue = response.detail.inputs.find((el) => el.name == "user-email")
    ? response.detail.inputs.find((el) => el.name == "user-email").value
    : false;

  responseModal.addClass(response.detail.status);
  responseModal.modal("show");

  //Title details
  if (responseStatus) {
    responseModalTitle.text(dataAttributes.successTitle);

    if (dataAttributes.pdfLink != undefined) {
      let downloadLink = document.createElement("a");
      downloadLink.href = dataAttributes.pdfLink;
      downloadLink.download = dataAttributes.pdfLink.substring(
        dataAttributes.pdfLink.lastIndexOf("/") + 1
      );
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }

    // ❌ CONFETTI REMOVED — nothing else changed
  } else {
    responseModalTitle.text(dataAttributes.failTitle);
  }

  // Message details
  if (dataAttributes.successMessage && responseStatus) {
    responseModalDesc.text(dataAttributes.successMessage);
  } else if (dataAttributes.failMessage && !responseStatus) {
    responseModalDesc.text(dataAttributes.failMessage);
  } else {
    if (customResponse) {
      responseModalDesc.html(
        customResponse.replace(
          "{user-mail}",
          '<span class="email"> ' + emailValue + "</span>"
        )
      );
    } else {
      if (emailValue) {
        responseModalDesc.html(
          response.detail.apiResponse.message.replace(
            "{user-mail}",
            '<span class="email"> ' + emailValue + "</span>"
          )
        );
      } else {
        responseModalDesc.text(response.detail.apiResponse.message);
      }
    }
  }

  responseModal.on("hidden.bs.modal", function () {
    responseModalTitle.text("");
    responseModalDesc.text("");
    responseModal.removeClass(response.detail.status);
  });
}
